/// <reference path="shopify.d.ts" />

import { ShopifyAjax } from "./goc-shopify-ajax.js"
import { LiquidData } from "./goc-shopify-liquid.js"

function main() {
  Alpine.store('product', {
    /**
     * @type {Shopify.Product}
     */
    data: null,

    init() {
      this.initProduct()
    },

    initProduct() {
      const handle = LiquidData.product().handle
      ShopifyAjax.product(handle).then(product => {
        this.data = product
      })
    }
  })
}

document.addEventListener('alpine:init', main)